import { render, staticRenderFns } from "./DataListView.vue?vue&type=template&id=65d39404"
import script from "./DataListView.vue?vue&type=script&lang=js"
export * from "./DataListView.vue?vue&type=script&lang=js"
import style0 from "./DataListView.vue?vue&type=style&index=0&id=65d39404&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports